<div class="right-adds">
  <ng-container [ngSwitch]="['b500'] | getProductName">
    <ng-container *ngSwitchCase="'b500'">
      <div class="add" *ngFor="let data of this._newSideBannerList" [ngStyle]="{ 'background-image': 'url(' + data?.FileName + ')' }" [routerLink]="[data.Link]"></div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="add" *ngFor="let data of this._newSideBannerList" [ngStyle]="{ 'background-image': 'url(' + data?.FileName + ')' }" (click)="goToLink(data.Link)"></div>
    </ng-container>
  </ng-container>
</div>
